import React from "react";
import { IventisTheme, sectionalMargin, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Container = styled.div`
    display: flex;
    padding: 0 ${sectionalMargin};
    height: 100%;
    background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.blank};
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: ${sectionalMargin};
`;

export const ErrorIcon = () => <StyledIcon icon="exclamation-triangle" size="5x" />;
export const TickIcon = () => <StyledIcon icon="check" size="5x" />;

const StyledIcon = styled(FontAwesomeIcon)`
    color: ${({ theme }: { theme: IventisTheme }) => theme.typographyColors.primary};
`;
